import React from "react";
import { Form, Button } from "antd";
import "./OIButton.scss";

interface IOIButton {
  label?: string;
  onClick?: React.MouseEventHandler<HTMLElement> | undefined;
  className?: string;
  htmlType?: "submit" | "button" | "reset" | undefined;
  disabled?: boolean;
  size?: "large" | "middle" | "small";
  type?: "primary";
  icon?: React.ReactNode;
  iconPositon?: "left" | "top" | "right";
  style?: React.CSSProperties | undefined;
  hidden?: boolean;
  loading?: boolean;
}

const OIButton = (props: IOIButton) => {
  const {
    label,
    onClick,
    className,
    htmlType,
    disabled,
    size,
    type,
    icon,
    iconPositon,
    style,
    hidden,
    loading,
  } = props;

  return (
    <Button
      className={"oi-btn-common " + className}
      htmlType={htmlType ?? "button"}
      type={type}
      onClick={onClick}
      size={size ?? "large"}
      disabled={disabled}
      style={style}
      hidden={hidden}
      loading={loading}
    >
      <>
        {iconPositon == "left" && (
          <>
            {icon}&nbsp;&nbsp;
          </>
        )}
        {iconPositon == "top" && (
          <>
            {icon}
            <br />
          </>
        )}
        {!iconPositon && <>{icon}</>}
        {label}
        {iconPositon == "right" && (
          <>
            &nbsp;&nbsp;{icon}
          </>
        )}
      </>
    </Button>
  );
};

export default OIButton;
